var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.713971 10.669C0.715907 11.0219 0.867143 11.3598 1.13474 11.6091C1.40233 11.8584 1.7646 11.9989 2.14265 12H7.85956C8.23811 11.9989 8.60082 11.8581 8.8685 11.6082C9.13618 11.3583 9.28707 11.0197 9.28823 10.6663V2.66743H0.713971V10.669ZM10 0.666514H7.50257L6.78566 0H3.21434L2.50037 0.666514H0V2.00023H10V0.666514Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete4);
export default __webpack_public_path__ + "static/media/delete4.f8117d7fca55b566714b6bc35a4b1f24.svg";
export { ForwardRef as ReactComponent };